// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__xtFy3","Open":"SideDrawer__Open__15SqF","Close":"SideDrawer__Close__26e9J","Logo":"SideDrawer__Logo__24sl5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigatioItems/SideDrawer/SideDrawer.css
// module id = 104
// module chunks = 0